import { z } from "zod";

export const FieldValueOptionSchema = z.object({
  label: z.string(),
  value: z.union([z.string(), z.number(), z.boolean()]),
});

/** A dropdown option resolved for a dynamic action or trigger field. */
export type FieldValueOption = z.infer<typeof FieldValueOptionSchema>;

export const FieldValuePageSchema = z.object({
  options: z.array(FieldValueOptionSchema),
  nextCursor: z.string().optional(),
});

/**
 * One page of dynamic field options. `nextCursor` is an opaque provider token;
 * its absence means the page is the last one.
 */
export type FieldValuePage = z.infer<typeof FieldValuePageSchema>;

/** Options a provider applies when resolving one page of dynamic field values. */
export interface FieldValueQuery {
  query?: string;
  cursor?: string;
}
